import React from "react";

const ProjectFour = () => {
  return (
    <div className="my-4">
      <h1 className="text-5xl text-black  my-4">Screen Shots</h1>

      <div className="carousel w-full">
        <div id="item1" className="carousel-item w-full">
          <img
            src="https://i.ibb.co/9WL3g6T/Screenshot-2024-06-09-232049.png"
            className="mx-auto w-fit"
          />
        </div>
        <div id="item2" className="carousel-item w-full">
          <img
            style={{ width: "800px", height: "782px" }}
            src="https://i.ibb.co/h98RjwM/Screenshot-2024-06-09-232004.png"
            className="mx-auto"
          />
        </div>
        <div id="item3" className="carousel-item w-full">
          <img
            style={{ width: "800px", height: "782px" }}
            src="https://i.ibb.co/Jn4JcDT/Screenshot-2024-06-09-231858.png"
            className="mx-auto"
          />
        </div>
        <div id="item4" className="carousel-item w-full">
          <img
            style={{ width: "800px", height: "782px" }}
            src="https://i.ibb.co/PDLq6Wr/Screenshot-2024-06-09-231813.png"
            className="mx-auto"
          />
        </div>
      </div>
      <div className="flex justify-center w-full py-2 gap-2">
        <a href="#item1" className="btn btn-xs">
          1
        </a>
        <a href="#item2" className="btn btn-xs">
          2
        </a>
        <a href="#item3" className="btn btn-xs">
          3
        </a>
        <a href="#item4" className="btn btn-xs">
          4
        </a>
      </div>
      <div>
        <p className="text-black">
          This is my latest full stack project. Featuring my knowledge in
          React.js, Node.js, Express.js, MongoDB, CRUD operations, and JWT
          authentication. FEATURES : User Authentication and Authorization
          Authenticate with JWT and allow access to protected routes. Google,
          Github login .Stores the User in MongoDb database. Profile Management
          View Profile Edit Profile CRUD Operations Create Items: Users can
          create listings with detailed information. Read Items Update Items
          Delete Items Search and Filtering
        </p>
      </div>
      <div className="flex flex-wrap justify-center my-10">
        <a
          className="btn btn-outline mr-4"
          href="https://waste-not-f415a.web.app/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Live Site{" "}
        </a>
        <a
          className="btn btn-outline mr-4"
          href="https://github.com/sasohan0/waste-not-frontend"
          target="_blank"
          rel="noopener noreferrer"
        >
          Front-End Code
        </a>
        <a
          className="btn btn-outline"
          href="https://github.com/sasohan0/waste-not-backend"
          target="_blank"
          rel="noopener noreferrer"
        >
          Backend Code
        </a>
      </div>
    </div>
  );
};

export default ProjectFour;
